import React, { useEffect, useState } from 'react';
import 'date-fns';
import {
  Box,
  Backdrop,
  CircularProgress,
  CardContent,
  CardHeader,
  Container,
  Card,
  Divider,
  Grid,
  TextField,
  MenuItem,
  DialogActions,
  TableCell,
  TableBody,
  TableRow,
  CardActions,
  TableContainer,
  Table,
  TableHead,
  createMuiTheme,
  Button,
  Snackbar,
  Breadcrumbs,
  Link,
  Typography,
  FormControlLabel,
  Switch
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { getUser } from 'src/utils/Common';
import SaveIcon from '@material-ui/icons/Save';
import axios from 'src/utils/axios';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/EmployeeExcelExport';
import TimelineIcon from '@material-ui/icons/Timeline';
import { sc } from 'src/utils/Common';
import SearchBar from 'material-ui-search-bar';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 275,
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

  cardscontent: {
    minHeight: 550
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  cardsMax: {
    // maxHeight: 230,
    minHeight: 230
  },
  cardsContentMax: {
    // maxHeight: 180,
    minHeight: 180
  },
  cards: {
    minHeight: 350
    // maxHeight: 500,
  },
  container: {
    maxHeight: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});
const localeMap = {
  tr: trLocale,
};



function ServiceShopOffWork(readonly) {
  const { t } = useTranslation('Technician_Management');
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const classes = useStyles();
  const locale = localStorage.getItem('i18nextLng');
  const [offWorkDescription, setOffWorkDescription] = useState('');
  const SessionUser = getUser();
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message1')
  });

  const [Required, setRequired] = useState(false);
  const [loading, setLoading] = useState(false);
  const [offWorkScreenData, setOffWorkScreenData] = useState([]);
  const [searched, setSearched] = useState('');
  const [initialRows, setinitialRows] = useState('');

  const [StartDateSearch, setStartDateSearch] = useState(new Date());

  const [EndDateSearch, setEndDateSearch] = useState( 
    moment()
  .startOf('day')
  .add(1, 'days')
  .add(12, 'hours')
  .format('YYYY-MM-DD'));
  const [RuleDateSearch, setRuleDateSearch] = useState( 
    moment()
  .startOf('day')
  .add(1, 'days')
  .add(12, 'hours')
  .format('YYYY-MM-DD'));

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  }

  const defaultServiceInfo = {
    service: SessionUser.ServiceShopName,
    ServiceShopId: SessionUser.ServiceShopId
  };

  const [serviceShop, setServiceShop] = useState(
    defaultServiceInfo
  );

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };

  const handleHistory = () => {
    setLoading(true);
    const input = {
      ServiceShopId: defaultServiceInfo.ServiceShopId,
    };
    axios
      .get(`/GetServiceShopOffWork/${input.ServiceShopId}`)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setOffWorkScreenData(Response);
          setinitialRows(Response);
        } else {
          setOffWorkScreenData([]);
        }
        setLoading(false);
      })
      .catch(error => {
        setOffWorkScreenData([]);
        setLoading(false);
      });
  };




  const handleSave = () => {
    if (!offWorkDescription) {
      setRequired(true);
      return
    }
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Data = {
      ServiceShopId: defaultServiceInfo.ServiceShopId,
      CreateEmployeeId: SessionUser.TechnicianId,
      Desc: offWorkDescription,
      Active: true,
      StartDate,
      EndDate,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetServiceShopOffWork', Data, config)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setOffWorkScreenData(Response);
          setinitialRows(Response);
          setresponseMessage({
            ErrorCode: responseMessage.ErrorCode,
            ErrorDescription: t('success_message1')
          });
          setUyariTip('success');
          setUyari(true);
          setOffWorkDescription([]);
        } else {
          setOffWorkScreenData([]);
        }
        setLoading(false);
      })
      .catch(error => {
        setOffWorkScreenData([]);
        setLoading(false);
      });
  };

  const handleChangeSwitch = (ServiceShopId, StartDate, EndDate, Active) => {
    setLoading(true);
    const data = {
      Active: Active,
      StartDate: StartDate,
      EndDate: EndDate,
      ServiceShopId: ServiceShopId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetServiceShopOffWork', data, config)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setOffWorkScreenData(Response);
          setresponseMessage({
            ErrorCode: responseMessage.ErrorCode,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
        } else {
          setOffWorkScreenData([]);
        }
        setLoading(false);
      })
      .catch(error => {
        setOffWorkScreenData([]);
        setLoading(false);
      });
  };

  const requestSearch = (searchedVal) => {  
    const filteredRows = initialRows.filter((item) => sc(
      item.Comment,
      searchedVal
    ));
    console.log(filteredRows);
    setOffWorkScreenData(filteredRows);

  };

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };


  return (
    <Page title="">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl" spacing={1}>
        <Breadcrumbs >
          <Link color="inherit">Sirius</Link>
          <Typography color="textPrimary">{t('lblServiceShopOffWork')}</Typography>
        </Breadcrumbs>
        <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
          <Alert
            onClose={uyariKapat}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        </Snackbar>
        <Divider />
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4} lg={12}>
                <TextField
                  disabled
                  size="small"
                  id="service"
                  autoComplete="no"
                  value={serviceShop.service}
                  onChange={event =>
                    setServiceShop({
                      ...serviceShop,
                      service: event.target.value
                    })}
                  fullWidth
                  label={t('lblServiceShop')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={4} lg={12}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      disablePast
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      label={t('lblStartDate')}
                      variant="outlined"
                      value={StartDateSearch}
                      onChange={e => handleChangeStartDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={4} lg={12}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      minDate={RuleDateSearch}
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      autoComplete="off"
                      label={t('lblEndDate')}
                      variant="outlined"
                      value={EndDateSearch}
                      onChange={e => handleChangeEndDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>

              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  id="Description"
                  multiline
                  rows={3}
                  autoComplete="no"
                  fullWidth
                  error={offWorkDescription?.length > 0 ? false : Required}
                  label={t('lblDescription')}
                  variant="outlined"
                  value={offWorkDescription}
                  onChange={(event) => setOffWorkDescription(
                    event.target.value
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={9} lg={12} />
              <Grid item xs={12} sm={3} lg={12}>
                <Button
                  align={"right"}
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  onClick={() => handleSave()}
                  endIcon={<SaveIcon />}
                >
                  {t('lblSave')}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} lg={12}>
                <Button
                  align={"right"}
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  onClick={() => handleHistory()}
                  endIcon={<TimelineIcon />}
                >
                  {t('lblHistory')}
                </Button>
              </Grid>
              <Grid item xs={4} sm={4} lg={5} />
              <Grid item xs={4} sm={4} lg={4}>
                <SearchBar
                  inputSizeSmall
                  value={searched}
                  onChange={searchVal => requestSearch(searchVal)}
                  onCancelSearch={() => cancelSearch()}
                  placeholder={t('lblSearch')}
                  style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                />
              </Grid>
            </Grid>
            <Container maxWidth="xl" spacing={1}>
            < br /> 
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                    </TableCell>
                    <TableCell align="left">
                      {t('lblServiceShop')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblDescription')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblStartDate')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblEndDate')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblActivePassive')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {offWorkScreenData?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">{ }</TableCell>
                      <TableCell align="left">{row.Dsc}</TableCell>
                      <TableCell align="left">{row.Comment}</TableCell>
                      <TableCell align="left">{moment(row.StartDate).format('DD-MM-YYYY')}</TableCell>
                      <TableCell align="left">{moment(row.EndDate).format('DD-MM-YYYY')}</TableCell>
                      <TableCell align="left">
                        <FormControlLabel
                          control={(
                            <Switch
                              checked={row.Active ? true : false}
                              onChange={(e) => handleChangeSwitch(row.ServiceShopId,
                                row.StartDate,
                                row.EndDate,
                                e.target.checked)}
                              name="checked"
                              inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                          )}
                          label={t('Active-Passive')}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
         </Container>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
export default ServiceShopOffWork
